<template>
  <div 
    class="m-hero-video-item hero"
  >
    <div 
      class="m-hero-video-item__content d-flex flex-column justify-content-center text-center h-100"
      :class="{
        '-has-play-button': hasModalVideo
      }"
    >
      <div v-if="!cookieConsent.marketing" class="m-hero-video-item__cookies-alert">
        {{ $t('videoCookies', 'Vi har en rigtig fin video, som vi gerne vil vise dig. Men før du kan se den, så skal du klikke her og') }}
        <a class="m-video__link" href="javascript:Cookiebot.renew()">{{ $t('acceptMarketingCookies', 'acceptere marketing cookies') }}</a>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-12 col-xl-6">
          <h2 class="mb-4 h2">
            {{ heroItem.headline }}
          </h2>
          <p
            v-if="!$isNullOrUndefined(heroItem.subline)"
            class="mb-6"
          >
            {{ heroItem.subline }}
          </p>


          <base-link
            v-if="!$isNullOrUndefined(heroItem.link)"
            class="text-decoration-none mb-6"
            :link="heroItem.link.url"
            :target="heroItem.link.target"
          >
            <base-button
              class="a-button -primary"
            >
              {{ heroItem.link.name }}
            </base-button>
          </base-link>
        </div>
      </div>
    </div>
    <div
      ref="videoContainer"
      class="overflow-hidden m-hero-video-item__video-container"
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <base-image
          v-if="!$isNullOrUndefined(poster)"
          :url="poster.url"
          :width="1410"
          :height="583"
          :alt-text="heroItem.imageAltText"
          class="h-100"
          image-class="m-hero-video-item__image"
        />
      </transition>

      <client-only>
        <div 
          v-if="cookieConsent.marketing"
          class="m-hero-video-item__video"
          :class="{
            '-active': hideImage,
            '-paused': showModal,
          }"
        >
          <youtube
            ref="video"
            :class="{
              '-active': hideImage,
              '-paused': showModal
            }"
            :player-vars="options"
            :video-id="heroItem.youtubeVideoIntroID"
            :nocookie="true"
            loading="lazy"
            @ready="ready"
            @playing="playing"
          />
        </div>
      </client-only>
      <div
        v-if="cookieConsent.marketing && !$isNullOrUndefined(heroItem.youtubeVideoID) && heroItem.youtubeVideoID !== ''"
        class="m-hero-video-item__video-btn"
        @click="toggleModal"
      >
        <base-icon
          class="m-hero-video-item__video-btn-icon"
          icon="play"
        />
      </div>
      <client-only>
        <portal v-if="showModal" to="modal">
          <modal
            :visible="showModal"
            @close="toggleModal"
          >
            <youtube
              width="853"
              height="505"
              class="m-hero-video-item__modal w-100"
              loading="lazy"
              :player-vars="modalVideoOptions"
              :video-id="heroItem.youtubeVideoID"
              :nocookie="true"
            />
            <template #close>
              <base-icon icon="close" />
            </template>
          </modal>
        </portal>
      </client-only>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/atoms/BaseButton';
import BaseLink from '@/components/atoms/BaseLink';
import BaseIcon from '@/components/atoms/BaseIcon';
import Modal from '@/components/molecules/Modal';
import BaseImage from '@/components/atoms/BaseImage';
import { Youtube } from 'vue-youtube';

export default {
  name: 'HeroVideoItem',
  components: {
    BaseButton,
    BaseLink,
    BaseIcon,
    Modal,
    BaseImage,
    Youtube
  },
  props: {
    heroItem: {
      default: () => {},
      required: true,
      type: Object
    },
    isActive: {
      default: false,
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      hideImage: false,
      player: null,
      cookieConsent: {
        marketing: false,
        statistics: false,
        preferences: false
      },
      options: {
        modestbranding: 1,
        mute: 1,
        autoplay: 1,
        playsinline: 1,
        rel: 0,
        iv_load_policy: 3,
        controls: 0,
        autoHide: 1,
        loop: 1,
        playlist: this.heroItem.youtubeVideoIntroID
      },
      modalVideoOptions: {
        modestbranding: 1,
        autoplay: 1,
        start: 0
      },
      showModal: false,
    };
  },
  computed: {
    cdnUrl () {
      return this.$store.getters['site/getCdnUrl'];
    },
    hasIntroVideo () {
      return !this.$isNullOrUndefined(this.heroItem.youtubeVideoIntroID) && this.heroItem.youtubeVideoIntroID !== '';
    },
    hasModalVideo () {
      return !this.$isNullOrUndefined(this.heroItem.youtubeVideoID) && this.heroItem.youtubeVideoID !== '';
    },
    poster () {
      return !this.$isNullOrUndefined(this.heroItem?.image) && this.heroItem?.image?.length ? this.heroItem.image[0] : null;
    }
  },
  watch: {
    isActive: {
      immediate: true,
      handler: function (isActive) {
        if (isActive && this.player && this.hasIntroVideo) {
        this.hideImage = true;
        this.player.playVideo();
      } else if (this.player) {
        this.hideImage = false;
        this.player.pauseVideo();
      }
      }
    }
  },
  mounted () {
    let self = this;
    this.cookieConsent = window.Cookiebot?.consent;
    window.addEventListener('CookiebotOnConsentReady', function () {
      self.cookieConsent = window.Cookiebot.consent;
    }, false);
    window.addEventListener('CookiebotOnAccept', function () {
      self.cookieConsent = window.Cookiebot.consent;
    }, false);
    window.addEventListener('CookiebotOnDecline', function () {
      self.cookieConsent = window.Cookiebot.consent;
    }, false);
  },
  methods: {
    ready (player) {
      this.player = player;
    },
    playing () {
      this.hideImage = true;
    },
    toggleModal () {
      if (this.showModal && this.player) {
        this.showModal = false;
        this.hideImage = this.hasIntroVideo ? true : false;
        this.player.playVideo();
      } else if (this.player) {
        this.showModal = true;
        this.hideImage = false;
        this.player.pauseVideo();
      } else {
        this.showModal = true;

      }
    }
  }
};
</script>
